export default "__VITE_ASSET__8d64f752__"